import { FC } from "react";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import styled from "@emotion/styled";
import { SettingsTabBarSectionContent } from "./settings-tab-bar.types";
import { SettingsTabBarItem } from "./settings-tab-bar-item";

export interface SettingsTabBarSectionProps {
  isFirst: boolean;
  selectedItemId: string;
  section: SettingsTabBarSectionContent;
}

export const SettingsTabBarSection: FC<SettingsTabBarSectionProps> = ({
  isFirst,
  selectedItemId,
  section,
}) => {
  return (
    <Wrapper>
      <StyledSectionLabel
        $isFirst={isFirst}
        variant={MDSTextVariant.TextXs}
        weight={MDSTextWeight.SemiBold}
        color={MDSTextColor.Secondary}
      >
        {section.label}
      </StyledSectionLabel>
      <ItemContentWrapper>
        {section.items.map(item => (
          <SettingsTabBarItem key={item.id} selectedItemId={selectedItemId} item={item} />
        ))}
      </ItemContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
});

const StyledSectionLabel = styled(MDSText)<{ $isFirst: boolean }>(({ theme, $isFirst }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: `${$isFirst ? theme.spacing[2] : theme.spacing[3]} ${theme.spacing[2]} ${theme.spacing[2]} ${theme.spacing[5]}`,
  userSelect: "none",
  "@container mds-panel (max-width: 750px)": {
    display: `none`,
  },
}));

const ItemContentWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
});
